
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { SchedulablePresenter, OutletPresenter } from 'shared/presenters';
import { defined, RecursivePartial } from 'shared/presenters/presenter';
import widgetRoutes from 'enums/routes';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Time_Slot_Bookings } from 'shared/presenters/graphqlTypes';
dayjs.extend(duration);
export interface BreadcrumbStructureProps {
    categorySlug: string;
    widgetSlug: string;
    outlet: OutletPresenter;
    schedulable: SchedulablePresenter;
}
export interface EventProps {
    categorySlug: string;
    widgetSlug: string;
    outlet: OutletPresenter;
    schedulable: SchedulablePresenter;
    timeSlot: RecursivePartial<Time_Slot_Bookings>;
}
const EventScript = ({ schedulable, timeSlot, outlet, categorySlug, widgetSlug }: EventProps) => {
    const starts = dayjs(timeSlot.start);
    const ends = dayjs(timeSlot.finish);
    const duration = dayjs.duration(ends.diff(starts)).toISOString();
    const event = {
        '@context': 'http://schema.org',
        '@type': 'Event',
        location: {
            '@type': 'Place',
            name: `${outlet.name}`,
            address: {
                '@type': 'PostalAddress',
                streetAddress: `${[schedulable.address?.building_name, schedulable.address?.street_name].join(', ')}`,
                addressLocality: `${schedulable.address?.city}`,
                postalCode: `${schedulable.address?.post_code}`,
                addressCountry: `${schedulable.address?.country}`
            }
        },
        organizer: {
            '@type': 'Organization',
            name: `${outlet.name}`,
            url: `${widgetRoutes.HOME.url({ widgetSlug })}`
        },
        name: `${schedulable.name()}`,
        offers: {
            '@type': 'Offer',
            price: `${schedulable.price_pence}`,
            priceCurrency: `${outlet.currency()}`,
            url: `${widgetRoutes.ACTIVITY.url({ activitySlug: defined(schedulable.slug), categorySlug: categorySlug, widgetSlug, utm_source: 'marketplace', utm_campaign: 'gttd' })}`,
            availability: 'https://schema.org/InStock',
            validFrom: `${dayjs(schedulable.created_at).toISOString()}`
        },
        startDate: `${starts.toISOString()}`,
        endDate: `${ends.toISOString()}`,
        image: `${schedulable.imageURL()}`,
        description: `${schedulable.description().replace(/(<([^>]+)>)/gi, '')}`,
        duration: `${duration}`
    };
    return (<script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(event)
        }}/>);
};
const GoogleStructuredDataEvent = ({ categorySlug, widgetSlug, outlet, schedulable }: BreadcrumbStructureProps) => {
    return (<>
      {schedulable.time_slot_bookings?.map(timeSlot => {
            return (<EventScript key={timeSlot.id} categorySlug={categorySlug} widgetSlug={widgetSlug} outlet={outlet} schedulable={schedulable} timeSlot={timeSlot}/>);
        })}
    </>);
};
export default GoogleStructuredDataEvent;

    async function __Next_Translate__getStaticProps__1961a27d752__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Activity/GoogleStructuredDataEvent',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1961a27d752__ as getStaticProps }
  